import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=04c3c2cf&scoped=true"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplates.vue?vue&type=style&index=0&id=04c3c2cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3c2cf",
  null
  
)

export default component.exports